// DS: C59
/** A floating panel with links to share a deviation on social media */ import React from 'react';
import { useTranslation } from 'react-i18next';
import DesktopShareContent from './DesktopShareContent';
import s from './DesktopSharePopup.scss';
const DesktopSharePopup = ({ url , title , embedCode , media , biData , requestClose  })=>{
    const { t  } = useTranslation();
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['title']
    }, t('share.shareOnSocial')), /*#__PURE__*/ React.createElement(DesktopShareContent, {
        url: url,
        title: title,
        embedCode: embedCode,
        media: media,
        biData: biData,
        requestClose: requestClose
    }));
};
DesktopSharePopup.displayName = 'DesktopSharePopup';
export default DesktopSharePopup;
